import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Chip,
} from '@material-ui/core';
import { addAutoreply, getTemplates } from '../../common/whatsapp';
import { getCampaignData } from '../../common/campaign';

const CreateAutoreply = (props) => {
  const { phoneSelections, initialData, onSubmit, onCancel } = props;
  const { admin, username } = props.user;
  const defaultData = {
    name: '',
    phoneNumberId: '',
    keyword: '',
    cid: '', // Dropdown value
    campaignName: "",
    replyType: '', // Dropdown value (text, media, button)
    saveProspectInDb: false, // Toggle value
    replyData: {
      text: '', // Text reply
      url: '', // Media URL
      caption: '', // Media caption
    },
    webhooks: [], // Array of webhook URLs
    webhookUrl: [],
  };
  const [formData, setFormData] = useState(initialData || defaultData);
  const [webhookInput, setWebhookInput] = useState(''); // Temporary input for webhooks
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [campaignOptions, setCampaignOptions] = useState([]);

  // Pre-fill form data if in edit mode
  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    loadCampaign();
    loadTemplates();
  },[admin])

  const loadCampaign = async () => {
   
    const Campaigns = await getCampaignData(admin);
    console.log("campaign is ",Campaigns)
    const _options =[];
    Campaigns.forEach((element) => {
      _options.push({
        value: element._id,
        label: element.name,
      });
    });
    
    console.log(_options)

    setCampaignOptions(_options)
  } 

  const loadTemplates = async () =>{
    const templates = await getTemplates({admin, allTemplates:true});
    setTemplates(templates);
  }

  // Handle changes in form fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('replyData.')) {
      // Handle nested replyData fields
      const nestedField = name.split('.')[1];
      setFormData({
        ...formData,
        replyData: {
          ...formData.replyData,
          [nestedField]: value,
        },
      });
    } else {
      // Handle top-level fields
      setFormData({ ...formData, [name]: value });
    }
  };

  // Handle webhook input changes
  const handleWebhookInputChange = (e) => {
    setWebhookInput(e.target.value);
  };

  // Add a webhook URL
  const addWebhook = () => {
    if (webhookInput && !formData.webhooks.includes(webhookInput)) {
      setFormData({
        ...formData,
        webhookUrl: [...formData.webhooks, webhookInput],
      });
      setWebhookInput('');
    }
  };

  // Remove a webhook URL
  const removeWebhook = (webhook) => {
    setFormData({
      ...formData,
      webhookUrl: formData.webhookUrl.filter((wh) => wh !== webhook),
    });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!admin) return;

    setLoading(true);
    setError(null);

    // Add default webhook URL if saveProspectInDb is enabled
    if (formData.saveProspectInDb) {
      const defaultWebhookUrl = `https://web.betyphon.com/api/public/inboundleads?cid=${formData.cid}&&phone={{phone}}&&source=WHATSAPP_KEYWORD`;
      formData.webhookUrl = [...formData.webhooks, defaultWebhookUrl];
    }

    if(formData.cid){
      const campaignData = campaignOptions && campaignOptions.find((element) => {
        return element.value === formData.cid
      });
      formData.campaignName = campaignData.label;
    }


    try {
      const response = await addAutoreply({
        ...formData,
        admin,
        username,
      });

      if (response.insertedId || response.acknowledged) {
        onSubmit(formData); // Notify parent component
      } else {
        setError('Failed to create autoreply.');
      }
    } catch (err) {
      setError('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper style={{ padding: '20px', margin: '20px 0' }}>
      <Grid container spacing={1}>
         <Grid item xs={12} md={8}>
            <Typography variant="h5" gutterBottom>
            {initialData ? 'Edit Autoreply' : 'Create New Autoreply'}

            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Phone Selection *</InputLabel>
              <Select
                name="phoneNumberId"
                value={formData.phoneNumberId}
                onChange={handleChange}
                required
              >
                {phoneSelections &&
                  phoneSelections.map((user) => (
                    <MenuItem key={user.key} value={user.key}>
                      {user.value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
      </Grid>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* Name Field */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Name*"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Phone Selection Dropdown */}

          {/* Keyword Field */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Keyword"
              name="keyword"
              value={formData.keyword}
              onChange={handleChange}
              required
            />
          </Grid>

          {/* Reply Type Dropdown */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Reply Type</InputLabel>
              <Select
                name="replyType"
                value={formData.replyType}
                onChange={handleChange}
                required
              >
                <MenuItem value="">select</MenuItem>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="template">Template</MenuItem>
              </Select>
            </FormControl>
          </Grid>


          {/* Save Prospect Toggle */}
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.saveProspectInDb}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      saveProspectInDb: e.target.checked,
                    })
                  }
                  color="primary"
                />
              }
              label="Save Prospect in Database"
            />
          </Grid>

          {/* CID Dropdown */}
          {
            formData.saveProspectInDb && <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>Campaign </InputLabel>
              <Select
                name="cid"
                value={formData.cid}
                onChange={handleChange}
              >
                {campaignOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          }




          {/* Text Reply Field (Visible if replyType is 'text') */}
          {formData.replyType === 'text' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Reply Message"
                name="replyData.text"
                value={formData.replyData.text}
                onChange={handleChange}
                required
                multiline
                rows={4}
              />
            </Grid>
          )}

          {/* Media Fields (Visible if replyType is 'media') */}
          {formData.replyType === 'media' && (
            <>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Media URL"
                  name="replyData.url"
                  value={formData.replyData.url}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Caption"
                  name="replyData.caption"
                  value={formData.replyData.caption}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}

          

          {/* Template Reply Field (Visible if replyType is 'template') */}

          {formData.replyType === 'template' && (
            <Grid item xs={12}>
                <InputLabel>Template Selection</InputLabel>
              <Select
                fullWidth 
                label="Template" 
                name="replyData.template" 
                value={formData.replyData.template} 
                onChange={handleChange} 
                required 
              >
                {templates.map((template) => (
                  <MenuItem key={template.name} value={template.name}>
                    {template.name}
                  </MenuItem> 
                ))} 
              </Select> 
            </Grid> 
          )}


          {/* Webhooks Field */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Webhook URL"
              value={webhookInput}
              onChange={handleWebhookInputChange}
              onKeyPress={(e) => e.key === 'Enter' && addWebhook()}
            />
           <pre>
  {`https://example.com/webhook?phone={{phone}}&keyword={{keyword}}&cid={{cid}}&response={{response}}`}
</pre>
            <Button
              variant="outlined"
              color="primary"
              onClick={addWebhook}
              style={{ marginTop: '10px' }}
            >
              Add Webhook
            </Button>
            <div style={{ marginTop: '10px' }}>
              {formData.webhooks.map((webhook) => (
                <Chip
                  key={webhook}
                  label={webhook}
                  onDelete={() => removeWebhook(webhook)}
                  style={{ margin: '5px' }}
                />
              ))}
            </div>
          </Grid>



          {/* Submit Button */}
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Submit'}
            </Button>
            <Button
              onClick={onCancel}
              variant="outlined"
              color="secondary"
              style={{ marginLeft: '10px' }}
            >
              Cancel
            </Button>
          </Grid>

          {/* Error Message */}
          {error && (
            <Grid item xs={12}>
              <Typography variant="body2" color="error">
                {error}
              </Typography>
            </Grid>
          )}
        </Grid>
      </form>
    </Paper>
  );
};

export default CreateAutoreply;